import client from "../libs/HttpClient";

class FeaturesServices {
  static featuresList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/features?page=${page_no}`, request);
  }
  static deleteFeatures(params) {
    return client.delete(`delete-features`, { params });
  }
  static addFeatures(request) {
    return client.post(`/add-features`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateFeatures(request) {
    return client.post(`/edit-features`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewFeatures(params) {
    return client.get(`get-features`, { params });
  }
  static updateStatusFeatures(request) {
    return client.post(`/features-status`, request);
  }
}
export { FeaturesServices };
